import {
    SET_ORDER_APPROVAL_REQUEST,
    SET_APPROVAL_REQUEST_OPTION_,
    SET_QUANTITY_APPROVAL_OPTION,
    SET_SELECTED_OPTIONS_SUBMIT,
    SET_FINAL_SAVE_APPROVAL_MANAGEMENT,
    SET_IS_OVERRIDE_ACTION_APPLICABLE
} from "./OrderApprovalType"

const setOrderApprovalRequest = (orderApprovalRequest: any) => ({
    type: SET_ORDER_APPROVAL_REQUEST,
    orderApprovalRequest: orderApprovalRequest
});

const setApprovalRequestOption = (approvalRequestOption: any) => {
    return {
        type: SET_APPROVAL_REQUEST_OPTION_,
        approvalRequestOption: approvalRequestOption
    }
}

const setQuantityApprovalOption = (quantityApprovalOption: any) => {
    return {
        type: SET_QUANTITY_APPROVAL_OPTION,
        quantityApprovalOption: quantityApprovalOption
    }
}

const setSelectedOptionsSubmit = (selectedOptionsSubmit: any) => {
    return{
        type: SET_SELECTED_OPTIONS_SUBMIT,
        selectedOptionsSubmit: selectedOptionsSubmit
    }
}


const setIsOverrideActionApplicable = (isOverrideActionapplicable?: any) => {
    return{
        type: SET_IS_OVERRIDE_ACTION_APPLICABLE,
        isOverrideActionapplicable: isOverrideActionapplicable
    }
}
export {
    setOrderApprovalRequest,
    setApprovalRequestOption,
    setQuantityApprovalOption,
    setSelectedOptionsSubmit,
    setIsOverrideActionApplicable
}
